class DocumentEventAdapter {
    constructor() {
        this.events = {};
    }

    copy(value) {
        const tempInput = document.createElement('input');
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
    }

}

const documentEventAdapter = new DocumentEventAdapter();
export default documentEventAdapter;